export default __webpack_public_path__ + "static/media/girl-gas-car.3d5ec5a4.png";